import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=7425ff57&scoped=true"
import script from "./menu-item.vue?vue&type=script&lang=js"
export * from "./menu-item.vue?vue&type=script&lang=js"
import style1 from "./menu-item.vue?vue&type=style&index=1&id=7425ff57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7425ff57",
  null
  
)

export default component.exports